var React = require('react');

function Search (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M9.97998 9.98001L13.94 13.94","stroke":"#777777","strokeWidth":"1.32","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M11.3001 6.68C11.3001 9.23155 9.23161 11.3 6.68006 11.3C4.1285 11.3 2.06006 9.23155 2.06006 6.68C2.06006 4.12844 4.1285 2.06 6.68006 2.06C9.23161 2.06 11.3001 4.12844 11.3001 6.68Z","stroke":"#777777","strokeWidth":"1.32","key":1})]);
}

Search.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = Search;

Search.default = Search;
